"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingTransaction = void 0;
const _1 = require(".");
class PendingTransaction extends _1.DefaultModel {
    constructor(account, // indexed
    transaction_id, // indexed
    score_name, // indexed
    method, // indexed
    chain_id, amount, decimals, asset, timestamp, block_number) {
        super();
        this.account = account;
        this.transaction_id = transaction_id;
        this.score_name = score_name;
        this.method = method;
        this.chain_id = chain_id;
        this.amount = amount;
        this.decimals = decimals;
        this.asset = asset;
        this.timestamp = timestamp;
        this.block_number = block_number;
    }
    static getValidationMap() {
        return Object.assign({ account: 'number', chain_id: 'string', transaction_id: 'string', score_name: 'string', method: 'string', amount: 'string', decimals: 'number', asset: 'string', timestamp: 'number', block_number: 'number' }, super.getValidationMap());
    }
}
exports.PendingTransaction = PendingTransaction;
//# sourceMappingURL=pending_transactions.model.js.map